export function joinPaths(...paths: string[]): string {
  return paths.join('/')
}

export const ROOT_PATHS = {
  appRoot: '/',
  auth: '/auth',
  logout: '/auth/logout',
  signup: '/signup',
  dashboard: '/dashboard',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  dailyStats: '/daily-stats',
  aiMarketInsights: '/ai-market-insights',
  spreadCheck: '/spread-check',
  tradingLog: '/trading-log',
  cashFlow: '/cash-flow',
  tradingPlan: '/trading-plan',
  reports: '/reports',
  emailConfirmation: '/email-confirmation',
  error: '/error',
  settings: '/trading-accounts',
  profile: '/profile',
  importTrades: '/import-trades',
  education: '/education',
  contact: '/contact-us',
  accountDeletion: '/account-deletion',
  webinars: '/webinars',
  lesson: '/education/lesson',
  completedModule: '/education/completed-module',
  completedQuiz: '/education/completed-quiz',
  notCompletedQuiz: '/education/not-completed-quiz',
  onboarding: '/onboarding',
}

export const PATH_PARAMS = {}

export const APP_PATHS = {
  root: ROOT_PATHS.appRoot,
  signup: ROOT_PATHS.signup,
  auth: ROOT_PATHS.auth,
  logout: ROOT_PATHS.logout,
  emailConfirmation: ROOT_PATHS.emailConfirmation,
  dashboard: ROOT_PATHS.dashboard,
  importTrades: ROOT_PATHS.importTrades,
  forgotPassword: ROOT_PATHS.forgotPassword,
  resetPassword: ROOT_PATHS.resetPassword,
  dailyStats: ROOT_PATHS.dailyStats,
  aiMarketInsights: ROOT_PATHS.aiMarketInsights,
  spreadCheck: ROOT_PATHS.spreadCheck,
  tradingLog: ROOT_PATHS.tradingLog,
  cashFlow: ROOT_PATHS.cashFlow,
  tradingPlan: ROOT_PATHS.tradingPlan,
  reports: ROOT_PATHS.reports,
  createReport: joinPaths(ROOT_PATHS.reports, 'create-report'),
  error: ROOT_PATHS.error,
  settings: ROOT_PATHS.settings,
  profile: ROOT_PATHS.profile,
  contact: ROOT_PATHS.contact,
  accountDeletion: ROOT_PATHS.accountDeletion,
  education: ROOT_PATHS.education,
  // webinars: ROOT_PATHS.webinars,
  lesson: joinPaths(ROOT_PATHS.lesson, ':lessonId'),
  completedModule: joinPaths(ROOT_PATHS.completedModule, ':moduleId'),
  completedQuiz: joinPaths(ROOT_PATHS.completedQuiz, ':programId'),
  notCompletedQuiz: joinPaths(ROOT_PATHS.notCompletedQuiz, ':programId'),
  // webinar: joinPaths(ROOT_PATHS.webinars, ':webinarId'),
  onboarding: ROOT_PATHS.onboarding,
}

export enum ADMIN_PATHS {
  adminDashboard = '/admin-dashboard',
  activationFunnel = '/activation-funnel',
  featureUsage = '/feature-usage',
  traderProfitability = '/trader-profitability',
  churnSignals = '/churn-signals',
  mailchimp = '/mailchimp',
  activeSessions = '/active-sessions',
  adminEvents = '/admin-events',
  questionnaireAnalytics = '/questionnaire-analytics',
  linkClickAnalytics = '/link-click-analytics',
  users = '/users',
  accounts = '/accounts',
  propBreachedAccounts = '/prop-breached-accounts',
  blockedIps = '/blocked-ips',
  accountConnectionLogs = '/account-connection-logs',
  brokerIdentifiers = '/broker-identifiers',
  commissionBenchmark = '/commission-benchmark',
  cronControl = '/sync-tasks',
}
